import script from "./SwapSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwapSetting.vue?vue&type=script&setup=true&lang=ts"

import "./SwapSetting.vue?vue&type=style&index=0&id=0a981451&scoped=true&lang=css"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a981451"]])

export default __exports__